import React from 'react';
import { Table } from '@/components/ui';
import { Vehicle, VehicleHistory } from '../../../types/Vehicle';

interface VehicleHistorySectionProps {
  vehicle: Vehicle;
}

const VehicleHistorySection: React.FC<VehicleHistorySectionProps> = ({ vehicle }) => {
  const history = vehicle.vehicleHistory || [];

  return (
    <div>
      <h2>Vehicle History</h2>
      {history.length === 0 ? (
        <p>No history available for this vehicle.</p>
      ) : (
        <Table striped responsive>
            <thead>
              <tr>
                <th>Date</th>
                <th>Field</th>
                <th>Old Value</th>
                <th>New Value</th>
                <th>Changed By</th>
                <th>Comments</th>
              </tr>
            </thead>
            <tbody>
              {history.map((entry: VehicleHistory) => (
                <tr key={entry.id}>
                  <td>{new Date(entry.createdAt).toLocaleString()}</td>
                  <td>{entry.field || '-'}</td>
                  <td>{entry.oldValue || '-'}</td>
                  <td>{entry.newValue || '-'}</td>
                  <td>
                    {entry.changedByUser
                      ? `${entry.changedByUser.name} ${entry.changedByUser.lastName}`
                      : '-'}
                  </td>
                  <td>{entry.comments || '-'}</td>
                </tr>
              ))}
            </tbody>
          </Table>
      )}
    </div>
  );
};

export default VehicleHistorySection;

